import type { OrchestratedQueriesViewProps } from "@/domains/diagnostics/types"

import { BulkOperationsView } from "./bulk-operations-view"
import { PerformanceStatsView } from "./performance-stats-view"
import { QueryDetailsTableView } from "./query-details-table-view"
import { QueryErrorsView } from "./query-errors-view"
import { QueryStatusOverviewView } from "./query-status-overview-view"
import { RpcMetricsToggleView } from "./rpc-metrics-toggle-view"

export const OrchestratedQueriesView = ({
  statusOverview,
  performanceStats,
  bulkOperations,
  queryDetails,
  errors,
  rpcMetricsToggle,
}: OrchestratedQueriesViewProps) => {
  return (
    <div className="space-y-6">
      <QueryStatusOverviewView {...statusOverview} />
      <PerformanceStatsView {...performanceStats} />
      <RpcMetricsToggleView {...rpcMetricsToggle} />
      <BulkOperationsView {...bulkOperations} />
      <QueryDetailsTableView {...queryDetails} />
      <QueryErrorsView {...errors} />
    </div>
  )
}
